import { injectWeeklyContent } from "./inject-weekly-content.js";
import { injectWithLimit } from "./inject-with-limit.js";
import { INJECT_ANCHOR_SELECTOR } from "./config.js";

/**
 * Richtet eine Lazy-Injection für Weekly- und Bundle-Kacheln per
 * IntersectionObserver ein und lädt Inhalte erst beim Sichtbarwerden.
 * Gibt den Observer zurück, damit nachgeladene Kacheln ergänzt werden können.
 */
export function setupWeeklyLazyInjection(root = document, opts = {}) {
    const {
        rootMargin = "250px 0px",
        threshold = 0.01,
        fallbackConcurrency = 4,
        selector = INJECT_ANCHOR_SELECTOR,
    } = opts;

    const anchors = [...root.querySelectorAll(selector)].filter((a) => !a.__weeklyInjectObserved);

    if (!("IntersectionObserver" in window)) {
        injectWithLimit(root, fallbackConcurrency, selector);
        return null;
    }

    const io = new IntersectionObserver(
        (entries) => {
            for (const en of entries) {
                if (!en.isIntersecting) continue;
                io.unobserve(en.target);
                injectWeeklyContent(en.target);
            }
        },
        { rootMargin, threshold }
    );

    anchors.forEach((a) => {
        a.__weeklyInjectObserved = true;
        io.observe(a);
    });

    return io;
}
